'use client';

import { useEffect } from 'react';
import { usePathname } from '@/core/i18n/routing';
import { setBookingReturnPath } from '@/core/utils/booking-return-path';

/**
 * Remembers the last in-site page before booking so the location-step back
 * button can use browser history when the customer did not open booking directly.
 */
const useRememberBookingReturnPath = (): void => {
  const pathname = usePathname();

  useEffect(() => {
    setBookingReturnPath(pathname);
  }, [pathname]);
};

export default useRememberBookingReturnPath;
